module.exports = __webpack_public_path__ + "static/img/pzb-D4Ymfm-n.ecaebf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/pzb-D4Ymfm-n.png
// module id = T9Zz
// module chunks = 16